export const SIGNIN = 'signIn';
export const SIGNUP = 'signUp';
export const FORM = 'form';
export const BUTTONGROUP = 'buttonGroup';
//export const CONTACTS = 'CONTACTS'
export const RESERVED_CHANNEL_ID = "893db3bc-0f4a-44f1-a201-18d54424c310";
export var firebasePath;
(function (firebasePath) {
    firebasePath["USERS"] = "users";
    firebasePath["CHATLIST"] = "chatList";
    firebasePath["CHATS"] = "chats";
    firebasePath["FAVORITES"] = "favorites";
    firebasePath["BLACKLIST"] = "blacklist";
    firebasePath["CONTACTS"] = "contacts";
    firebasePath["CHANNELS"] = "channels";
    firebasePath["CHANNELS_INFO"] = "channelsInfo";
    firebasePath["MESSAGE"] = "messages";
})(firebasePath || (firebasePath = {}));
export var clickType;
(function (clickType) {
    clickType["CREATE_CHANNEL"] = "CREATE_CHANNEL";
    clickType["SETTINGS"] = "SETTINGS";
    clickType["SHOW_CHANNEL_INFO"] = "SHOW_CHANNEL_INFO";
    clickType["SHOW_USER_INFO"] = "SHOW_USER_INFO";
    clickType["ADD_TO_LIST_SUBSCRIBERS"] = "ADD_TO_LIST_SUBSCRIBERS";
    clickType["REMOVE_FROM_LIST_SUBSCRIBERS"] = "REMOVE_FROM_LIST_SUBSCRIBERS";
    clickType["CONTACTS"] = "CONTACTS";
})(clickType || (clickType = {}));
